import { enhanceSelects } from '../Components/select/index.js';

enhanceSelects('select:not(.no-lfm-select)');
